var map = {
	"./DataScience/follow.json": 32959,
	"./ai/follow.json": 48967,
	"./android/follow.json": 34263,
	"./arvr/follow.json": 95148,
	"./backend/follow.json": 19123,
	"./bioinformatics/follow.json": 4268,
	"./biotech/follow.json": 15084,
	"./blockchain/follow.json": 71027,
	"./creativedesign/follow.json": 90861,
	"./cybersecurity/follow.json": 73552,
	"./database/follow.json": 57119,
	"./devops/follow.json": 1410,
	"./edgecomputing/follow.json": 53429,
	"./embedded-system/follow.json": 13095,
	"./foss/follow.json": 35038,
	"./frontend/follow.json": 42062,
	"./generative-ai/follow.json": 27124,
	"./ios/follow.json": 66026,
	"./iot/follow.json": 35973,
	"./marketing/follow.json": 64112,
	"./photonics/follow.json": 22021,
	"./pm/follow.json": 23869,
	"./qa/follow.json": 13859,
	"./quantum-computing/follow.json": 9769,
	"./robotics-automation/follow.json": 72451,
	"./space-technology/follow.json": 87079,
	"./uiux/follow.json": 40992,
	"./web/follow.json": 94712
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 34702;
module.exports = webpackAsyncContext;